var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "buy-panel-wrapper-add-to-cart"
  }, [_vm.signInToBuy ? _c('button', {
    class: _vm.buttonClass ? _vm.buttonClass : ['buy-panel-add-to-cart', {
      'wide-cta': _vm.isAddToCartWideCta && !_vm.disableShare
    }, 'button', {
      'buy-panel-add-to-cart-loading': _vm.addToCartLoading
    }],
    attrs: {
      "disabled": _vm.disableAddToCart || !_vm.enableAddToCartButton,
      "type": "button"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.addToCartLoading,
      expression: "!addToCartLoading"
    }]
  }, [_vm._v(_vm._s(_vm.isMyAddToCart ? _vm.translations.buyPanelTmallPurchaseDesign : _vm.translations.buyPanelAddToCar))]), _c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.addToCartLoading,
      expression: "addToCartLoading"
    }],
    staticClass: "buy-panel-add-to-cart-spinner",
    attrs: {
      "size": "40"
    }
  })], 1) : _c('button', {
    class: _vm.buttonClass ? _vm.buttonClass : ['buy-panel-add-to-cart', 'buy-panel-sign-in-to-buy', 'button', 'secondary'],
    attrs: {
      "role": "button",
      "aria-label": _vm.translations.buyPanelSignInToBuy,
      "disabled": _vm.disableAddToCart || !_vm.enableAddToCartButton,
      "type": "button"
    },
    on: {
      "click": _vm.launchSignInToBuy
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translations.buyPanelSignInToBuy) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }